import React from "react";

/**
 * Thin wrapper: title + optional action + content area.
 * Same props as before — title, action, children, className —
 * just a softer, more polished shell (subtle elevation instead of
 * a flat border, tighter type, gentle hover lift).
 */
const ChartCard = ({ title, action, children, className = "" }) => (
  <div
    className={`group rounded-xl border border-neutral-200 dark:border-neutral-800 bg-white dark:bg-neutral-900 shadow-card dark:shadow-card-dark transition-shadow duration-200 hover:shadow-md dark:hover:shadow-black/30 ${className}`}
  >
    {(title || action) && (
      <div className="flex items-center justify-between gap-3 border-b border-neutral-100 dark:border-neutral-800 px-4 py-3">
        {title && (
          <h3 className="text-[11px] font-semibold uppercase tracking-wider text-neutral-500 dark:text-neutral-400">
            {title}
          </h3>
        )}
        {action && <div className="flex items-center gap-2">{action}</div>}
      </div>
    )}
    <div className="p-4">{children}</div>
  </div>
);

export default ChartCard;
